import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import Measure from 'react-measure';

import _ from 'lodash';
import cx from 'classnames';
import styles from './style.module.scss';

class BannerView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      width: 0,
      height: 0,
      aspectRatio: 1
    }
  }

  componentDidMount(){
    const mediaType = this.getBackgroundType(this.props.value);
    if(mediaType === 'video'){
      this.loadVideoPlayer();
    }
  }

  componentWillReceiveProps(nextProps){
    
  }

  getBackgroundImage(banner){
    if(banner && banner.background){
      var background = banner.background;
      if(typeof background === 'string'){
        return background;
      }else if(background.full){
        return background.full;
      }
    }

    return this.props.default;
  }

  getBackgroundType(banner){
    if(banner == null){
      return 'image';
    }

    if(banner.mediaType){
      return banner.mediaType;
    }

    var type = _.get(banner, 'background.type');
    if(type){
      return type;
    }

    return "image";
  }

  renderBackground(banner){
    const backgroundImage = this.getBackgroundImage(banner);
    const backgroundPosition = (banner ? banner.position : null) || 'center center';

    let style = {
      'backgroundImage': `url("${backgroundImage}")`,
      'backgroundPosition': backgroundPosition
    };

    return (
      <div className={styles.image} style={style}></div>
    );
  }

  loadVideoPlayer(){
    this.videoNode.addEventListener('loadeddata', () => {
      if(this.videoNode && this.videoNode.videoHeight > 0){
        const aspectRatio = this.videoNode.videoWidth / this.videoNode.videoHeight;
        this.setState({
          aspectRatio: aspectRatio
        })
      }
    })
  }

  renderVideo(banner){
    const backgroundImage = this.getBackgroundImage(banner);
    const backgroundPosition = (banner ? banner.position : null) || 'center center';

  
    const style = {
      objectPosition: backgroundPosition
    }

    return (
      <video ref={node => this.videoNode = node} type='video/mp4' 
        autoPlay playsInline muted loop
        className={cx(styles.video, backgroundPosition)}
        style={style}
        key={backgroundImage}
      >
        <source src={backgroundImage} type='video/mp4'/>
      </video>
    );
  }

  render() {
    const banner = this.props.value || _.get(this.props.account, 'collectionSettiings.banner');
    const mediaType = this.getBackgroundType(banner);
    const backgroundFilter = banner ? banner.filter : null;

    var backgroundProperties = {
      'backgroundImage': '',
      'backgroundColor': ''
    };

    switch (backgroundFilter) {
      case 'gradientTop':
        backgroundProperties.backgroundImage = `linear-gradient(-24.8312deg, rgba(255,255,255,0), rgba(${banner.overlayColor.r}, ${banner.overlayColor.g}, ${banner.overlayColor.b}, ${banner.overlayColor.a}))`;
        break;
      case 'gradientBottom':
        backgroundProperties.backgroundImage = `linear-gradient(135.862deg, rgba(255,255,255,0), rgba(${banner.overlayColor.r}, ${banner.overlayColor.g}, ${banner.overlayColor.b}, ${banner.overlayColor.a}))`;
        break;
      case 'lines':
      case 'stripes':
      case 'dots':
        backgroundProperties.backgroundImage = '';
        backgroundProperties.backgroundColor = banner.overlayColor ? `rgba(${banner.overlayColor.r}, ${banner.overlayColor.g}, ${banner.overlayColor.b}, ${banner.overlayColor.a})` : `rgba(0,0,0,0)`;
        break;
      default:
        backgroundProperties.backgroundImage = '';
        backgroundProperties.backgroundColor = '';
    }

    return (
      <Measure bounds
        onResize={(contentRect) => {
          this.setState({
            width: contentRect.bounds.width,
            height: contentRect.bounds.height
          })
        }}>
        {({ measureRef }) =>
          <div ref={measureRef} className={cx(styles.banner, styles[mediaType] , {
            [styles.activeBanner] : _.get(this,"props.isActive")
          })}>

            {_.get(this,"props.applyGradient") && <div className={styles.gradientoverlay} />}
            {mediaType === 'image' &&
              this.renderBackground(banner)
            }

            {mediaType === 'video' &&
              this.renderVideo(banner)
            }

            {backgroundFilter &&
              <div className={cx(styles.overlay, styles[backgroundFilter])} style={backgroundProperties}/>
            }
          </div>
        }
      </Measure>
    );
  }
}

BannerView.defaultProps = {
  
}

const Banner = connect(
  (state, ownProps) => {
    return {
      
    }
  },
  null
)(BannerView)

export default Banner;